import createAdjDetailEntry from './createAdjDetailEntry'
import copyObjectNoRef from './copyObjectNoRef'
//----------------------------
// change combat reaction adj
//----------------------------
export default function changeCombatReactionAdj({ character, key, toggle }) {
  console.log('----------------------------------------')
  console.log('IN changeCombatReactionAdj')
  console.log('key = ' + key + ' / toggle = ' + toggle)
  //----------------
  // arg validation
  //----------------
  if (!character) {
    console.log('NO character passed in!')
    return null
  }
  if (!key || (key != 'shield' && key != 'second_weapon')) {
    console.log('INVALID key passed in!')
    return character
  }
  if (typeof toggle !== 'boolean') {
    console.log('INVALID toggle passed in!')
    return character
  }
  let adjs = character.ability_adjs ? copyObjectNoRef(character.ability_adjs) : []
  let adj = null
  // =================================================================
  // A. toggle ON
  // -------------
  if (toggle === true) {
    const opposite_key = key == 'shield' ? 'second_weapon' : 'shield'
    const removeOppositeRes = _removeCRAdj({ key: opposite_key, adjs })
    if (removeOppositeRes) {
      adjs = removeOppositeRes.adjs
    }
    //------------------------------------------
    // add cr adj (for shield or second weapon)
    //------------------------------------------
    adj = _addCRAdj({ key })
    const alreadyExists = adjs.some(
      (existingAdj) => existingAdj?.name === adj.name && existingAdj?.adj_reason === adj.adj_reason,
    )
    if (!alreadyExists) {
      adjs.push(adj)
    }
    // =================================================================
    // B. toggle OFF
    //---------------
  } else {
    //---------------------------------------------
    // remove cr adj (for shield or second weapon)
    //---------------------------------------------
    let res = _removeCRAdj({ key, adjs })
    if (res) {
      adj = res.adj
      adjs = res.adjs
    }
  }
  //--------
  // return
  //--------
  return { adj, adjs }
  // =================================================================
  // INTERNAL FUNCTION: add cr adj
  //-------------------------------
  function _addCRAdj({ key }) {
    console.log('ADDING COMBAT REACTION ADJ FOR ' + key)
    //------------------------------------------
    // add cr adj (for shield or second weapon)
    //------------------------------------------
    const adj = createAdjDetailEntry({
      id: null,
      name: 'cr',
      adj_reason: key == 'shield' ? 'Shield Equipped' : 'Second-Weapon Equipped',
      adj_value: 1,
      item: null,
      editable: false,
      rune: '',
      source: 'ability',
      persistable: true,
    })
    return adj
  }
  // =================================================================
  // INTERNAL FUNCTION: remove cr adj
  //----------------------------------
  function _removeCRAdj({ key, adjs }) {
    let adj = null
    //---------------------------------------------
    // remove cr adj (for shield or second weapon)
    //---------------------------------------------
    let idx = adjs.findIndex(
      (a) =>
        a.name == 'cr' &&
        (key == 'shield'
          ? a.adj_reason == 'Shield Equipped'
          : a.adj_reason == 'Second-Weapon Equipped'),
    )
    if (idx > -1) {
      console.log('REMOVING COMBAT REACTION ADJ FOR ' + key + ' at idx = ' + idx)
      adjs.splice(idx, 1)
      //-----------------------------------------------------
      // forces recalcs/rebuild reasons (thru handleCalcTotalsRebuildReasonAdjs)
      //------------------------------------------------------
      adj = createAdjDetailEntry({
        id: null,
        name: 'cr',
        adj_reason: '',
        adj_value: 0,
        item: null,
        editable: false,
        rune: '',
        source: 'ability',
        persistable: true,
      })
    } else {
      console.log('NO COMBAT REACTION ADJ FOR ' + key + ' TO REMOVE')
    }
    return { adj, adjs }
  }
}
